import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Vant, { Field, Lazyload } from 'vant';
import 'vant/lib/index.css';
import 'virtual:svg-icons-register';

import App from './App.vue';
import AppImage from './components/AppImage.vue';
import AppNavBar from './components/AppNavBar.vue';
import AppSvgIcon from './components/AppSvgIcon.vue';
import router from './router';
import i18n from './i18n';
import { getAnyAccountAddress, useProfileStore } from './stores/profile';
import { useThemeStore } from './stores/theme';
import { themeColors } from './api/common';
import { loadProfile } from '@/utils/storage';
import { applyAppLocale } from '@/utils/locale';
import './utils/rem';
import './styles/base.scss';
import '@vant/touch-emulator';

const app = createApp(App);
const pinia = createPinia();

Field.props.autocomplete = {
  type: String,
  default: 'off'
};

app.use(Lazyload);
app.component('AppImage', AppImage);
app.component('AppSvgIcon', AppSvgIcon);

router.beforeEach((to, from, next) => {
  const profile = loadProfile() || {};
  const profileStore = useProfileStore(pinia);
  const hasAdress = getAnyAccountAddress(profile?.currentAccount);
  const hasAuth = Boolean(hasAdress || profile?.token);
  const publicPaths = [
    '/login',
    '/wallet/invite-register',
    '/referral-guide',
    '/mine/about',
    '/mine/support-email',
    '/mine/support-chat'
  ];
  const publicPrefixes = ['/auth/'];
  const isPublicRoute = publicPaths.includes(to.path)
    || publicPrefixes.some((prefix) => to.path.startsWith(prefix));

  const storeHasAuth = Boolean(
    getAnyAccountAddress(profileStore.currentAccount)
    || profileStore.token
  );

  if (!hasAuth && storeHasAuth) {
    profileStore.$reset();
    profileStore.ensureDefaults();
  }

  if (hasAuth) {
    if (to.path === '/login') {
      next('/home/index');
      return;
    }
    next();
    return;
  }

  if (isPublicRoute) {
    next();
    return;
  }

  next('/login');
});

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(Vant);
app.component('AppNavBar', AppNavBar);

const profileStore = useProfileStore();
profileStore.ensureDefaults();
const themeStore = useThemeStore();
themeStore.ensureDefaults();
void themeStore.loadFromApi({
  request: () => themeColors({ name: 'zorpay' })
}).catch(() => undefined);
applyAppLocale(i18n, profileStore.locale);

app.mount('#app');
